export default __webpack_public_path__ + "static/media/engineering.e2b4ee6e.webp";